import { createContext } from "react";

const UserContext = createContext(undefined);

export default UserContext;